var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Oval_00000067931484424663287240000009606320008471064973_);}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Artboard"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Oval_00000128447195411786494030000018194367249533001884_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.0269,
    y1: 1000.583,
    x2: 1.0269,
    y2: 999.5904,
    gradientTransform: "matrix(1000 0 0 -1000 -526.9451 1000583)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2AABEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#229ED9"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Oval_00000128447195411786494030000018194367249533001884_)"
    },
    cx: 500,
    cy: 500,
    r: 500
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    className: "st1",
    d: "M226.3,494.7c145.8-63.5,243-105.4,291.6-125.6c138.9-57.8,167.7-67.8,186.5-68.1 c4.1-0.1,13.4,1,19.4,5.8c5.1,4.1,6.5,9.6,7.1,13.5s1.5,12.8,0.8,19.7c-7.5,79.1-40.1,270.9-56.6,359.5c-7,37.5-20.8,50-34.2,51.3 c-29,2.7-51.1-19.2-79.2-37.6c-44-28.8-68.9-46.8-111.6-75c-49.4-32.5-17.4-50.4,10.8-79.6c7.4-7.6,135.3-124,137.8-134.6 c0.3-1.3,0.6-6.2-2.3-8.8s-7.2-1.7-10.4-1c-4.4,1-74.7,47.5-210.9,139.4c-20,13.7-38,20.4-54.2,20c-17.9-0.4-52.2-10.1-77.7-18.4 c-31.3-10.2-56.2-15.6-54-32.8C190.3,513.3,202.7,504.1,226.3,494.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.be874c6d1b757bbf54f5af00d56e7e15.svg";
export { ForwardRef as ReactComponent };